import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const userAgentFromServerContext = createContext("");
const useUserAgentFromServer = () => {
  return window !== void 0 ? window.navigator?.userAgent : "";
};
function UserAgentFromServerContextProvider({
  userAgent,
  children
}) {
  return /* @__PURE__ */ jsx(userAgentFromServerContext.Provider, { value: userAgent, children });
}

export { UserAgentFromServerContextProvider, useUserAgentFromServer, userAgentFromServerContext };
//# sourceMappingURL=userAgentFromServer.mjs.map
